// 查询参与人
export const SEARCH_EVENT_USER = 'SEARCH_EVENT_USER';
export const SEARCH_EMAIL_USER = 'SEARCH_EMAIL_USER';
export const QUERY_EVENT = 'QUERY_EVENT';
export const QUERY_EVENT_REQUEST = 'QUERY_EVENT_REQUEST';
export const ADD_EVENT = 'ADD_EVENT';
export const GET_BUSINESS_OPPORTUNITY = 'GET_BUSINESS_OPPORTUNITY';
export const DELETE_EVENT = 'DELETE_EVENT';
export const GET_PROJECT = 'GET_PROJECT';
export const GET_PEOJECT_TASK = 'GET_PEOJECT_TASK';
export const GET_MEETING_ROOM = 'GET_MEETING_ROOM';
export const GET_REMAINING_WORKTIME = 'GET_REMAINING_WORKTIME';
export const GET_TASK_ITEM_OPTIONS = 'GET_TASK_ITEM_OPTIONS';
export const FORMDATA_BIND = 'FORMDATA_BIND';
export const GET_BUSINESS_UNIT_LIST = 'GET_BUSINESS_UNIT_LIST';
export const GET_DEPART_MEND_USERS = 'GET_DEPART_MEND_USERS';
